export default __webpack_public_path__ + "static/media/shop.f4c52ab2.webp";